import React, { Component, useState, useEffect } from "react";
import styles from "./css/ServicePlaces.module.css";


const home_maintain_services = [
  {
    name: "Boston, MA",
    icon: "/assets/img/boston.png",
  },
  {
    name: "Cambridge, MA",
    icon: "/assets/img/Cambridge, MA.png",
  },
  {
    name: "Worcester, MA",
    icon: "/assets/img/Worcester.png",
  },
  {
    name: "2. Boston, MA",
    icon: "/assets/img/boston.png",
  },
  {
    name: "Cambridge, MA",
    icon: "/assets/img/Cambridge, MA.png",
  },
  {
    name: "Worcester, MA",
    icon: "/assets/img/Worcester.png",
  },
  {
    name: "3. Boston, MA",
    icon: "/assets/img/boston.png",
  },
  {
    name: "Cambridge, MA",
    icon: "/assets/img/Cambridge, MA.png",
  },
  {
    name: "Worcester, MA",
    icon: "/assets/img/Worcester.png",
  },

];

export class ServicePlaces extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
       current_services: [],
       current_dot_index: 0,
    }

    this.carousalCycle = null
  }

  componentDidMount () {
    const all_services = [].concat(home_maintain_services);
    let perDots = (home_maintain_services.length/3);
    perDots = (home_maintain_services.length%3)>0?perDots+1:perDots;
    let dots = [];
    for(let i=0;i<perDots;i++) {
      dots.push(1)
    }
    
    this.setState({
      current_services: all_services.splice(0,3),
      dots: dots
    })



    let carousalCycle = setInterval(() => {
      this.selectImageSet(-1);
    }, 2000);

    this.carousalCycle = carousalCycle;

  }

  selectImageSet = (index) => {

    const all_services = [].concat(home_maintain_services);

    if(index==-1) {
      index = (this.state.current_dot_index+1)%3;
      this.setState({
        current_services: all_services.splice(index*3,3),
        current_dot_index: index
      })
    } else {
      this.setState({
        current_services: all_services.splice(index*3,3),
        current_dot_index: index
      })
    }
  }
  

  stopCarousal = () => {
    clearInterval(this.carousalCycle)
  }


  startCarousal = () => {

    let carousalCycle = setInterval(() => {
      this.selectImageSet(-1);
    }, 2000);

    this.carousalCycle = carousalCycle;

  }


  render() {
    return (
      <div className={styles.servicePlaces}>
        <div className={styles.servicePlacesInner}>
          <div className={styles.topHeading}>
            <div className={styles.headingCont}>
              <h2>We are Providing Service</h2>
            </div>
            <div className={styles.descriptionCont}>
              <p>
                Many place providing our service, Boston, Lowell, other many
                place give our service
              </p>
            </div>
          </div>
          <div className={styles.homeServicesCont}>
            <div className={styles.homeServicesList}>
              <div className={styles.homeServicesListInner} onMouseOver={this.stopCarousal} onMouseOut={this.startCarousal}>
                {this.state.current_services.map((singleService, index) => (
                  <SingleService
                    key={index}
                    service={singleService}
                  ></SingleService>
                ))}
              </div>
            </div>
            <DotsController dots={this.state.dots}
            current_dot_index={this.state.current_dot_index}
            selectImageSet={this.selectImageSet}></DotsController>
          </div>
        </div>
      </div>
    );
  }
}

const SingleService = (props) => {
  const [service, setService] = useState(props.service);

  useEffect(() => {
    setService(props.service);


  }, [props]);


  return (
    <div className={styles.singleService}>
      <div className={styles.iconCont}>
        <div className={styles.iconContInner}>
          <img src={service.icon} />
        </div>
      </div>
      <div className={styles.serviceName}>
        <p>{service.name}</p>
      </div>
    </div>
  );
};





const DotsController = (props) => {
  const [dots, setDots] = useState(props.dots);
  const [currentDotPosition,setCurrentDotPosition] = useState(props.current_dot_index);
  
  useEffect(() => {
    setDots(props.dots);
    setCurrentDotPosition(props.current_dot_index);


  }, [props]);

  return (
    dots?
    <div className={styles.dotsContainer}>
      <div className={styles.dotsContainerInner}>
        <div className={styles.dotsCluster}> 
        {
          dots.map((dot, index)=>(
            <span className={styles.singleDot} key={index} onClick={()=>props.selectImageSet(index)} style={{backgroundColor: currentDotPosition==index?`rgba(45, 183, 91, 0.3)`:`rgba(45, 183, 91, 1)` }}></span>
          ))
        }
        </div>
      </div>
    </div>:
    null
  )
}

export default ServicePlaces;
